import React, { Fragment } from 'react'
import List from '../../../../components/Project/Resources/Drivers/List'
import DriverModal from '../../../../components/Project/Resources/Drivers/DriverModal'

function Drivers(props) {
  return (
    <Fragment>
      <DriverModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

Drivers.propTypes = {}
Drivers.defaultProps = {}

export default Drivers
